import { useResetDocumentTemplateMutation } from "@common/api/document-templates"
import { ConfirmDialog } from "@common/components/shared/confirm-dialog"
import { handleError } from "@common/utils"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"
import { requirePermission } from "@/lib/require-permission"
import { KIND_LABELS } from "../-lib/kinds"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/templates/$kind/revert",
)({
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(
      queryClient,
      "document_template:update",
      "/settings/workspace/general",
    ),
  component: RevertDialog,
})

function RevertDialog(): React.ReactElement {
  const { kind } = Route.useRouteContext()
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const mutation = useResetDocumentTemplateMutation()
  const label = KIND_LABELS[kind]

  const close = () =>
    navigate({
      to: "/settings/workspace/templates/$kind",
      params: { kind },
      search: true,
    })

  const confirm = () =>
    mutation.mutate(
      { kind },
      {
        onSuccess: () => {
          showToast("Reverted", `${label} template reverted.`, "success")
          close()
        },
        onError: (error) => handleError(error, showToast),
      },
    )

  return (
    <ConfirmDialog
      title={`Revert the ${label.toLowerCase()} template?`}
      description="Your company's version is replaced by the Fleetcraft default. Unsaved edits are lost."
      action="Revert"
      tone="default"
      pendingAction="Reverting…"
      pending={mutation.isPending}
      onConfirm={confirm}
      onCancel={close}
    />
  )
}
